import { render, staticRenderFns } from "./StatisticsMerchant.vue?vue&type=template&id=b55817d0&scoped=true&"
import script from "./StatisticsMerchant.vue?vue&type=script&lang=js&"
export * from "./StatisticsMerchant.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsMerchant.vue?vue&type=style&index=0&id=b55817d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55817d0",
  null
  
)

export default component.exports